import { msalInstance } from '../auth/authConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error('No accounts found');
    }

    const request = {
      scopes: ['User.Read'],
      account: accounts[0]
    };

    const response = await msalInstance.acquireTokenSilent(request);
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${response.accessToken}`
    };
  } catch (error) {
    console.error('Error getting auth headers:', error);
    return {
      'Content-Type': 'application/json'
    };
  }
};

export interface Line {
  _id: string;
  _Value_DE: string;
  createdAt: string;
  updatedAt: string;
}

export interface LineImportResult {
  created: number;
  updated: number;
  errors: string[];
}

// **ALLE LINIEN ABRUFEN**
export const getLines = async (): Promise<Line[]> => {
  try {
    console.log('[LINE API] Fetching lines...');
    
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/lines`, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || 'Failed to fetch lines');
    }

    console.log(`[LINE API] Successfully fetched ${result.data?.length || 0} lines`);
    return result.data || [];
  } catch (error) {
    console.error('[LINE API] Error fetching lines:', error);
    throw error;
  }
};

// **LINIEN IMPORTIEREN**
export const importLines = async (lines: any[]): Promise<LineImportResult> => {
  try {
    console.log('[LINE API] Importing lines:', lines.length);
    
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/lines/import`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ lines })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || 'Failed to import lines');
    }

    console.log('[LINE API] Import successful:', result.data);
    return result.data;
  } catch (error) {
    console.error('[LINE API] Error importing lines:', error);
    throw error;
  }
};

// **EINZELNE LINIE ERSTELLEN**
export const createLine = async (lineData: { _Value_DE: string }): Promise<Line> => {
  try {
    console.log('[LINE API] Creating line:', lineData);
    
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/lines`, {
      method: 'POST',
      headers,
      body: JSON.stringify(lineData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || 'Failed to create line');
    }

    console.log('[LINE API] Line created successfully:', result.data);
    return result.data;
  } catch (error) {
    console.error('[LINE API] Error creating line:', error);
    throw error;
  }
};

// **LINIE LÖSCHEN**
export const deleteLine = async (id: string): Promise<void> => {
  try {
    console.log('[LINE API] Deleting line:', id);
    
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/lines/${id}`, {
      method: 'DELETE',
      headers
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || 'Failed to delete line');
    }

    console.log('[LINE API] Line deleted successfully');
  } catch (error) {
    console.error('[LINE API] Error deleting line:', error);
    throw error;
  }
};
